import angular from 'angular';
import salesHomeComponent from './sales-home.component';
import SalesHomeService from './sales-home.service';
// import salesHomeConfig from './sales-home.config';

let salesHomeModule = angular.module('app.salesHome',[])
  .component('salesHome', salesHomeComponent)
  .service('SalesHomeService', SalesHomeService);
  // .config(salesHomeConfig);

export default salesHomeModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/sales-home/sales-home.js
 **/